import React, { useContext, useEffect, useState, useMemo, useRef } from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { TextField } from '@material-ui/core'
import { MuiThemeProvider } from '@material-ui/core'
import { autocompletePerspectiveTheme } from 'designer/component/system/themes/elementTheme'
import httpClient from 'utility/httpClient.util'
import { debounceCallback } from 'utility/debounceCallback.util'
import objectPath from 'object-path'
import {
  Form,
  Card,
  Collapse,
  Dropdown,
  ListGroup,
  Media,
} from 'react-bootstrap'
import Avatar from '@mui/material/Avatar'
import { ViewInAr, ArrowBackIos, Login, Apps } from '@mui/icons-material'
import { ConfigContext } from 'contexts/ConfigContext'
import * as actionType from '../../../../../store/actions'
import { Link, useHistory, useRouteMatch, useLocation } from 'react-router-dom'
import routes from '../../../../../routes'
import Select from 'react-select'
import FeatherIcon from 'feather-icons-react'
import useAuth from 'hooks/useAuth'
import { stringAvatar } from 'utility/common.util'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useTranslation } from 'react-i18next'

const prefixPage = ''
const HOSP_SURGERY_DASHBOARD_PATH = '/hospital/hosp-surgery'
const SURGERY_PERSPECTIVE_PATH = '/patient-file/surgery'
const SURGERY_OPERATION_PATH =
  '/patient-file/surgery/display/form/form-surgery-operation'
const SURGERY_ANESTHETIC_PATH =
  '/patient-file/surgery/display/form/form-surgery-anesthetic'
const SURGERY_SERVICE_CHARGE_PATH =
  '/patient-file/surgery/display/form/form-surgery-service-charge'

const resolveCustomMenuPath = (pageMenu, routePath, defaultPath) => {
  const title = String(objectPath.get(pageMenu, 'data.title') || '')
    .trim()
    .toLowerCase()
  const path = String(objectPath.get(pageMenu, 'data.path') || '').toLowerCase()
  const resolvedPath = String(defaultPath || '').toLowerCase()
  const isSurgeryDashboard =
    path.includes('page-surgery') || resolvedPath.includes('page-surgery')
  const isSurgeryOperation =
    routePath === SURGERY_PERSPECTIVE_PATH &&
    (title === 'operation' ||
      path.includes('form-surgery-operation') ||
      path.includes('form-operation') ||
      resolvedPath.includes('form-operation'))
  const isSurgeryAnesthetic =
    routePath === SURGERY_PERSPECTIVE_PATH &&
    (title === 'anesthesia' ||
      title === 'anesthetic' ||
      title.includes('วิสัญญี') ||
      /form-surgery-(anesthesia|anesthetic)/.test(path))
  const isSurgeryServiceCharge =
    routePath === SURGERY_PERSPECTIVE_PATH &&
    (title.includes('ค่าบริการ') ||
      title === 'service charge' ||
      /form-surgery-(service|charge|cost|fee)/.test(path))

  if (isSurgeryDashboard) return HOSP_SURGERY_DASHBOARD_PATH
  if (isSurgeryOperation) return SURGERY_OPERATION_PATH
  if (isSurgeryAnesthetic) return SURGERY_ANESTHETIC_PATH
  if (isSurgeryServiceCharge) return SURGERY_SERVICE_CHARGE_PATH

  return defaultPath
}

const NavPerspective = ({
  outside,
  collapseMenu,
  setPerspectiveMenu,
  setPerspectiveMenuStatus = () => {},
  menuRetryToken = 0,
  perspective,
  setPerspective,
}) => {
  const { isLoggedIn, user, config, setAccountPerspective } = useAuth()
  const history = useHistory()
  const pathname = history.location.pathname
  const firstPath = pathname.split('/')[1]
  const secondPath = pathname.split('/')[2]
  const [perspectiveList, setPerspectiveList] = useState([])
  const [allPerspectiveList, setAllPerspectiveList] = useState([])
  const [allowedPerspectiveList, setAllowedPerspectiveList] = useState([])
  const [perspectiveLoaded, setPerspectiveLoaded] = useState(false)
  const configContext = useContext(ConfigContext)
  const { layout, layoutType, menuClick, perspectiveMenu, menuParams } = configContext.state
  const { dispatch } = configContext
  const isDarkMenu = layout !== 'horizontal' && ['menu-dark', 'dark'].includes(layoutType)
  const perspectiveId = perspective?.perspectiveId || ''
  const menuList = perspectiveMenu || []
  const match = useRouteMatch(pathname)
  const location = useLocation()
  const matchUrl = match.url
  const components = routes.find((route) => route.routes)
  const [selectPerspective, setSelectPerspective] = useState(false)
  const { t } = useTranslation('common')
  const queryParams = new URLSearchParams(history.location.search)
  const urlParams = Object.fromEntries([...queryParams])
  const hn = queryParams.get('hn')
  const [isSetMenu, setIsSetMenu] = useState(false)
  const perspectiveRequestRef = useRef(0)
  const menuRequestRef = useRef(0)

  const clearPerspectiveMenu = () => {
    setPerspectiveMenu([])
    dispatch({ type: actionType.PERSPECTIVE_MENU, perspectiveMenu: [] })
  }

  const getPerspective = async () => {
    const requestId = perspectiveRequestRef.current + 1
    perspectiveRequestRef.current = requestId
    setPerspectiveMenuStatus('loading')
    let api = `/designer/perspective/search?perPage=1000`
    let allPerspective = await httpClient
      .get(api)
      .then(({ data }) => data.data)
      .catch(() => null)
    if (requestId !== perspectiveRequestRef.current) return []
    if (!allPerspective) {
      setAllPerspectiveList([])
      clearPerspectiveMenu()
      setPerspectiveMenuStatus('error')
      return null
    }
    setAllPerspectiveList(allPerspective)
    // Return the modified or original allPerspective array
    const result = filterPerspectiveByPermission(allPerspective)
    return result
  }

  const filterPerspectiveByPermission = (allPerspective) => {
    //Limit with Permission
    const find = config.find(({ configCode }) => configCode === 'menu_visible')
    //console.log('getPer',find)
    // Create a Set of perspective IDs

    const newAllowList = []
    if (find) {
      allPerspective.forEach((item) => {
        find.jsonData.permissions.forEach((permission) => {
          permission.perspective.forEach((perspective) => {
            if (perspective.perspectiveId === item.perspectiveId)
              newAllowList.push(item)
          })
        })
      })
    }
    let userPermissions = user.permissions || []
    if (userPermissions.includes('role:ckdoctor:admin')) {
      //newAllowList = allPerspective;
    }
    return newAllowList
  }

  useEffect(() => {
    let isSubscribed = true

    const loadPerspective = async () => {
      let list = await getPerspective()
      if (!isSubscribed || !list) return
      setAllowedPerspectiveList(list)
      setPerspectiveLoaded(true)
    }

    loadPerspective()

    return () => {
      isSubscribed = false
    }
  }, [])

  const foundMatch = useMemo(() => {
    let routesList = components?.routes || []
    let foundMatch =
      routesList.find(({ path }) => {
        let a = path.split('/').filter((value) => value)
        let b = matchUrl.split('/').filter((value) => value)
        let aLength = a.length
        let bLength = b.length
        if (bLength > aLength) {
          let diff = bLength - aLength
          b.splice(0, diff)
          bLength = b.length
        }
        if (bLength === aLength) {
          let check = a.every((element, index) => {
            if (element.startsWith(':') || element === '*') {
              return true
            }
            return element === b[index]
          })
          return check
        }
      }) || {}

    return foundMatch
  }, [`/${firstPath}/${secondPath}`])

  const paramMatch = useRouteMatch(foundMatch)?.params || {}

  useEffect(() => {
    if (perspectiveId) {
      getPerspectiveMenu(perspectiveId)
    }
  }, [perspectiveId, menuRetryToken])

  useEffect(() => {
    if (!perspectiveLoaded) return
    let list = allowedPerspectiveList
    let perspective = list.find(
      (item) =>
        item.routePath === `/${firstPath}` ||
        item.routePath === `/${firstPath}/${secondPath}`,
    )

    if (perspective) {
      clearPerspectiveMenu()
      setPerspectiveMenuStatus('loading')
      dispatch({ type: actionType.PERSPECTIVE, perspective: perspective })
      setPerspective(perspective)
    } else {
      if (selectPerspective) return
      setPerspective(null)
      setPerspectiveMenuStatus('idle')
    }
    if (perspective) {
      if (perspective.isRoot) {
        let filterList = list.filter(
          (item) => item.isRoot === perspective.isRoot,
        )
        setAccountPerspective(filterList)
        setPerspectiveList(filterList)
      } else {
        let filterList = list.filter(
          (item) =>
            item.isRoot === perspective.isRoot &&
            item.routePath.startsWith(`/${firstPath}`),
        )
        setAccountPerspective(filterList)
        setPerspectiveList(filterList)
      }
    } else {
      let filterList = list.filter((item) => item.isRoot === 1)
      setAccountPerspective(filterList)
      setPerspectiveList(filterList)
    }
    return () => {
      setPerspectiveList([])
    }
  }, [firstPath, secondPath, perspectiveLoaded, allowedPerspectiveList])

  const filterMenuByPermission = (allMenus) => {
    const find = config.find(({ configCode }) => configCode === 'menu_visible')
    //console.log('getPer',find)
    // Create a Set of perspective IDs

    const newAllowList = []
    if (find) {
      allMenus.forEach((item) => {
        find.jsonData.permissions.forEach((permission) => {
          permission.perspective.forEach((perspective) => {
            if (perspective.pathsId.includes(item.pageMenuDesignId)) {
              newAllowList.push(item)
            }
          })
        })
      })
    }
    let userPermissions = user.permissions || []
    if (userPermissions.includes('role:ckdoctor:admin')) {
      //newAllowList = allMenus;
    }
    return newAllowList
  }

  const getPerspectiveMenu = async (perspectiveId, isReturn = false) => {
    const requestId = menuRequestRef.current + 1
    menuRequestRef.current = requestId
    if (!isReturn) {
      clearPerspectiveMenu()
      setPerspectiveMenuStatus('loading')
    }
    let api = `/designer/perspective-menu-collection/getByPerspective?perspectiveId=${perspectiveId}`
    let response = await httpClient
      .get(api)
      .then(({ data }) => data.data)
      .catch(() => null)
    if (requestId !== menuRequestRef.current) return null
    if (!response) {
      clearPerspectiveMenu()
      setPerspectiveMenuStatus('error')
      return null
    }

    let menuList = {}
    filterMenuByPermission(response).forEach((item) => {
      let pageMenu = item.pageMenuDesign
      if (pageMenu.isDeleted === 1) return
      objectPath.set(menuList, `${item.pageMenuDesignId}`, {
        perspectiveId: item.perspectiveId,
        perspectiveMenuCollectionId: item.perspectiveMenuCollectionId,
        checked: true,
        data: {
          id: pageMenu.data.menuId,
          pageMenuDesignId: pageMenu.pageMenuDesignId,
          title: t(`${prefixPage}${pageMenu.data.title}`),
          type: pageMenu.menuType,
          icon: '',
          seq: pageMenu.seq,
          color: pageMenu.data.titleColor,
          showMenu: true,
          menu: pageMenu,
          access: pageMenu.data.access || [],
          unlisted: false,
        },
        seq: item.seq,
      })
      if (pageMenu.menuType !== 'item') {
        objectPath.set(menuList, `${item.pageMenuDesignId}.data.children`, [])
      }
    })

    if (isReturn) {
      let checkList = menuList
      menuList = await createGroupPerspective(checkList)
      menuList = await createCollapsePerspective(menuList, checkList)
      menuList = await createItemPerspective(menuList, checkList)
      if (requestId !== menuRequestRef.current) return null
      return menuList
    }
    createPerspectiveMenu(menuList, requestId)
  }

  const CustomToggle = React.forwardRef(({ children, onClick, style }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault()
        onClick(e)
      }}
    >
      <span style={{ fontSize: '16px', ...style }}>
        {children}
        <i className="fas fa-caret-down m-l-5" />
      </span>
    </a>
  ))

  const renderSelectingView = () => {
    return (
      <ListGroup.Item as="li" bsPrefix=" ">
        <Dropdown>
          <Dropdown.Toggle as={Link} variant="link" to="#" id="dropdown-basic">
            <Apps />
          </Dropdown.Toggle>
          <Dropdown.Menu
            alignRight
            className="notification notification-scroll"
          >
            <div className="noti-head">
              <h6 className="d-inline-block m-b-0">
                <Apps /> {t('Switch to')}
              </h6>
            </div>
            <PerfectScrollbar>
              <ListGroup
                as="ul"
                bsPrefix=" "
                variant="flush"
                className="noti-body noti-room"
              >
                <ListGroup.Item as="li" bsPrefix=" " className="n-title">
                  <p className="m-b-0">{t('Available Apps')}</p>
                </ListGroup.Item>
                {perspectiveList
                  .filter(({ visibleOnParams }) => {
                    // If visibleOnParams is null or an empty array, it passes
                    if (!visibleOnParams || visibleOnParams.length === 0)
                      return true

                    // Otherwise, check if queryParams contains any of the visibleOnParams
                    return visibleOnParams.every((param) =>
                      queryParams.get(param),
                    )
                  })
                  .map((item, index) => (
                    <ListGroup.Item
                      as="li"
                      key={index}
                      bsPrefix=" "
                      className="notification "
                      style={{ padding: '10px 15px' }}
                    >
                      <Media>
                        <Avatar
                          {...stringAvatar(item.name)}
                          className="avatar"
                        />
                        <Media.Body>
                          <p>
                            <strong> {item.name}</strong>
                          </p>
                          <p>{item.routePath}</p>
                        </Media.Body>
                      </Media>
                    </ListGroup.Item>
                  ))}
              </ListGroup>
            </PerfectScrollbar>
          </Dropdown.Menu>
        </Dropdown>
      </ListGroup.Item>
    )
  }

  const PerspectiveDropdown = ({ toggleStyle = {} }) => {
    const [options, setOptions] = useState(perspectiveList)
    const [input, setInput] = useState('')

    return (
      <MuiThemeProvider theme={autocompletePerspectiveTheme}>
        {options.length > 1 ? (
          <Dropdown
            onSelect={async (eventKey) => {
              //const newValue = options[eventKey]
              const newValue = options.find(
                (option) => option.perspectiveId * 1 === eventKey * 1,
              )
              dispatch({ type: actionType.PERSPECTIVE, perspective: newValue })
              dispatch({ type: actionType.MENU_CLICK, menuClick: null })
              clearPerspectiveMenu()
              setPerspectiveMenuStatus(newValue ? 'loading' : 'idle')
              setPerspective(newValue || null)
              setOptions(perspectiveList)
              setSelectPerspective(true)
              if (!newValue) {
                let list = allowedPerspectiveList
                let filterList = list.filter((item) => item.isRoot === 1)
                setAccountPerspective(filterList)
                setPerspectiveList(filterList)
              }
              let matchList = matchUrl.split('/')
              let routePath = newValue?.routePath || ''
              let routePathList = routePath.split('/')
              routePathList.forEach((item, index) => {
                matchList[index] = item
              })
              //matchList.join('/'),
              let historyData = {
                pathname: routePath,
                search: history.location.search,
              }
              history.push(historyData)
            }}
          >
            <Dropdown.Toggle
              as={CustomToggle}
              id="dropdown-custom-components"
              style={{ ...toggleStyle }}
            >
              <Apps className="mr-1" style={appStyle} />{' '}
              {t(`${prefixPage}${perspective?.name || 'Switch to'}`)}
            </Dropdown.Toggle>

            <Dropdown.Menu
              className={isDarkMenu ? 'bg-dark' : ''}
              style={{
                maxHeight: 'calc(100vh - 180px)',
                minWidth: '220px',
                overflowY: 'auto',
                overscrollBehavior: 'contain',
              }}
            >
              <Dropdown.Header
                className={isDarkMenu ? 'text-light' : ''}
                style={{ width: 'calc(100% - 20px)' }}
              >
                {t(`${prefixPage}Switch to`)}
              </Dropdown.Header>
              {options
                .slice() // Create a copy to avoid mutating the original array
                .filter(({ visibleOnParams }) => {
                  // If visibleOnParams is null or an empty array, it passes
                  if (!visibleOnParams || visibleOnParams.length === 0)
                    return true

                  // Otherwise, check if queryParams contains any of the visibleOnParams
                  return visibleOnParams.every((param) =>
                    queryParams.get(param),
                  )
                })
                .sort((a, b) => a.name.localeCompare(b.name)) // Sort by option.name
                .map((option, index) => (
                  <Dropdown.Item
                    eventKey={option.perspectiveId}
                    key={index}
                    active={option?.name === perspective?.name}
                    className={`d-inline-flex ${
                      isDarkMenu
                        ? option?.name === perspective?.name
                          ? 'bg-primary text-white'
                          : 'bg-dark text-light'
                        : ''
                    }`}
                    style={{ width: 'calc(100% - 20px)' }}
                  >
                    <Avatar
                      {...stringAvatar(
                        option.name,
                        {
                          width: 28,
                          height: 28,
                          background: option.bgColor || 'inherit',
                        },
                        1,
                      )}
                      className="avatar m-r-5"
                    />
                    <span className="label-name">
                      {t(`${prefixPage}${option.name}`)}{' '}
                    </span>
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <span className="f-16">
            {t(perspective?.name) || t(`${prefixPage}App Loading...`)}
          </span>
        )}
      </MuiThemeProvider>
    )
  }

  const PerspectiveAutoComplete = () => {
    const [options, setOptions] = useState(perspectiveList)
    const [input, setInput] = useState('')

    return (
      <MuiThemeProvider theme={autocompletePerspectiveTheme}>
        <Autocomplete
          size="small"
          sx={{ width: 300 }}
          options={options}
          getOptionLabel={(option) => option?.name}
          value={perspective || null}
          onChange={async (event, newValue) => {
            dispatch({ type: actionType.PERSPECTIVE, perspective: newValue })
            dispatch({ type: actionType.MENU_CLICK, menuClick: null })
            clearPerspectiveMenu()
            setPerspectiveMenuStatus(newValue ? 'loading' : 'idle')
            setPerspective(newValue || null)
            setOptions(perspectiveList)
            setSelectPerspective(true)
            if (!newValue) {
              let list = allowedPerspectiveList
              let filterList = list.filter((item) => item.isRoot === 1)
              setPerspectiveList(filterList)
            }
            let matchList = matchUrl.split('/')
            let routePath = newValue?.routePath || ''
            let routePathList = routePath.split('/')
            routePathList.forEach((item, index) => {
              matchList[index] = item
            })
            let historyData = {
              pathname: matchList.join('/'),
              search: history.location.search,
            }
            history.push(historyData)
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              size="small"
              placeholder="Perspective"
            />
          )}
        />
      </MuiThemeProvider>
    )
  }

  const updateCollapseMenu = (menuList, pageMenu, createList, seq) => {
    if (!pageMenu.data.groupMenuId) {
      pageMenu.unlisted = true
    }
    let pageMenuDesignId = pageMenu.pageMenuDesignId
    let refGroupMenuDesignId =
      objectPath.get(pageMenu, 'data.refGroupMenuDesignId') || []
    let menuLevel = objectPath.get(pageMenu, 'data.menuLevel') || []
    if (refGroupMenuDesignId && !menuLevel.includes(refGroupMenuDesignId)) {
      menuLevel = [refGroupMenuDesignId].concat(menuLevel)
    }
    if (pageMenuDesignId && !menuLevel.includes(pageMenuDesignId)) {
      menuLevel = menuLevel.concat([pageMenuDesignId])
    }

    menuLevel.reduce((o, pageMenuDesignId) => {
      if (!pageMenuDesignId) return o

      let index = o.findIndex(
        (item) => item.pageMenuDesignId === pageMenuDesignId,
      )

      if (createList.includes(pageMenuDesignId)) {
        if (index >= 0) {
          return o[index].children
        }
        return o
      } else {
        createList.push(pageMenuDesignId)
      }

      if (pageMenuDesignId === pageMenu.pageMenuDesignId) {
        let icon = ''
        let iconSource = objectPath.get(pageMenu, 'data.iconSource') || ''
        let iconName = objectPath.get(pageMenu, 'data.icon') || ''
        let iconText = objectPath.get(pageMenu, 'data.iconText') || ''
        let iconType = objectPath.get(pageMenu, 'data.iconType') || ''
        let iconColor = objectPath.get(pageMenu, 'data.iconColor') || ''
        let iconTextColor = objectPath.get(pageMenu, 'data.iconTextColor') || ''

        if (iconType === 'char') {
          icon = `ck-badge badge-primary`
        } else {
          icon = iconName
        }
        o.push({
          id: pageMenu.data.groupMenuId + '-' + pageMenu.data.menuId,
          pageMenuDesignId: pageMenu.pageMenuDesignId,
          title: t(`${prefixPage}${pageMenu.data.title}`),
          type: 'collapse',
          icon: icon,
          iconType: iconType,
          iconSource: iconSource,
          iconText: iconText,
          iconColor: iconColor,
          iconTextColor: iconTextColor,
          color: pageMenu.data.titleColor,
          access: pageMenu.data.access || [],
          isMain:
            pageMenu.refPageMenuDesignId === pageMenu.data.refGroupMenuDesignId,
          children: [],
          menu: pageMenu,
          seq: seq,
        })

        return o
      }

      return o[index]?.children || o
    }, menuList)

    return menuList
  }

  const updateItemMenu = (list, pageMenu, seq) => {
    if (!pageMenu.data.groupMenuId) {
      pageMenu.unlisted = true
    }
    let groupMenuId = pageMenu.data.groupMenuId
    let refPageMenuDesignId = pageMenu.refPageMenuDesignId
    let icon = ''
    let iconSource = objectPath.get(pageMenu, 'data.iconSource') || ''
    let iconName = objectPath.get(pageMenu, 'data.icon') || ''
    let iconText = objectPath.get(pageMenu, 'data.iconText') || ''
    let iconType = objectPath.get(pageMenu, 'data.iconType') || ''
    let iconColor = objectPath.get(pageMenu, 'data.iconColor') || ''
    let iconTextColor = objectPath.get(pageMenu, 'data.iconTextColor') || ''

    if (iconType === 'char') {
      icon = `ck-badge badge-primary`
    } else {
      icon = iconName
    }

    let path = objectPath.get(pageMenu, 'data.path') || ''
    let pathList = path.split('/')
    let linkType = objectPath.get(pageMenu, 'data.linkType') || ''
    let url = ''
    let routePath = perspective?.routePath || ''

    if (linkType === 'router') {
      pathList.forEach((item, index) => {
        if (item.startsWith(':')) {
          let value = objectPath.get(paramMatch, item.replace(':', '')) || ''
          path = path.replace(item, value)
        }
      })
      if (path.startsWith(routePath)) {
        url = path
      } else {
        if (path.startsWith('/')) {
          url = `${routePath}` + path
        } else {
          url = `${routePath}` + '/' + path
        }
      }
    } else {
      url = objectPath.get(pageMenu, 'data.url') || ''
    }

    const customPath = resolveCustomMenuPath(pageMenu, routePath, url)
    if (linkType === 'router' && customPath === SURGERY_OPERATION_PATH) {
      url = customPath
    }

    let locationSearch = history.location.search
    let isClearLocationSearch =
      objectPath.get(pageMenu, 'data.locationSearch') === 0
    if (pageMenu.isRoot && isClearLocationSearch) {
      locationSearch = ''
    }

    return list.map((item) => {
      if (refPageMenuDesignId) {
        if (refPageMenuDesignId === item.menu.pageMenuDesignId) {
          item.children.push({
            groupMenuId,
            id: `${groupMenuId}-${pageMenu.data.menuId}`,
            pageMenuDesignId: pageMenu.pageMenuDesignId,
            title: t(`${prefixPage}${pageMenu.data.title}`),
            type: 'item',
            icon: icon,
            iconType: iconType,
            iconSource: iconSource,
            iconText: iconText,
            iconColor: iconColor,
            iconTextColor: iconTextColor,
            color: pageMenu.data.titleColor,
            menu: pageMenu,
            access: pageMenu.data.access || [],
            url: url + locationSearch,
            linkType: linkType,
            seq: seq,
          })
        }
      } else {
        if (groupMenuId === item.id) {
          item.children.push({
            groupMenuId,
            id: `${groupMenuId}-${pageMenu.data.menuId}`,
            pageMenuDesignId: pageMenu.pageMenuDesignId,
            title: t(`${prefixPage}${pageMenu.data.title}`),
            type: 'item',
            icon: icon,
            iconType: iconType,
            iconSource: iconSource,
            iconText: iconText,
            iconColor: iconColor,
            iconTextColor: iconTextColor,
            color: pageMenu.data.titleColor,
            menu: pageMenu,
            access: pageMenu.data.access || [],
            url:
              (url === SURGERY_OPERATION_PATH
                ? url
                : `${perspective.routePath}/${url}`) + locationSearch,
            seq: seq,
          })
        }
      }
      if (item.children) {
        item.children.sort((a, b) => a.seq - b.seq)
      }
      return {
        ...item,
        children: item.children && updateItemMenu(item.children, pageMenu, seq),
      }
    })
  }

  const createGroupPerspective = async (checkList) => {
    let response = Object.values(checkList)
    response = response.filter(
      ({ data, checked = false, indeterminate = false }) =>
        data.type === 'group' && (checked || indeterminate),
    )
    response.sort((a, b) => a.seq - b.seq)
    let menuList = []
    response.forEach(({ data, seq }, index) => {
      let menu = data.menu
      let newMenu = {
        id: menu.data.menuId,
        pageMenuDesignId: menu.pageMenuDesignId,
        type: 'group',
        title: menu.title,
        seq: seq,
        menu: menu,
        color: menu.data.titleColor,
        access: [],
        children: [],
      }
      menuList.push(newMenu)
    })
    return menuList
  }

  const createCollapsePerspective = async (menuList, checkList) => {
    let response = Object.values(checkList)
    response = response.filter(
      ({ data, checked = false, indeterminate = false }) =>
        data.type === 'collapse' && (checked || indeterminate),
    )
    response.sort((a, b) => a.seq - b.seq)
    let createList = []
    response.forEach(({ data, seq }) => {
      menuList = updateCollapseMenu(menuList, data.menu, createList, seq)
    })
    return menuList
  }

  const createItemPerspective = async (menuList, checkList) => {
    let response = Object.values(checkList)
    response = response.filter(
      ({ data, checked = false, indeterminate = false }) =>
        data.type === 'item' && (checked || indeterminate),
    )
    response.sort((a, b) => a.seq - b.seq)
    response.forEach(({ data, seq }) => {
      menuList = updateItemMenu(menuList, data.menu, seq)
    })
    return menuList
  }

  const createPerspectiveMenu = async (checkList, requestId) => {
    if (requestId && requestId !== menuRequestRef.current) return
    if (Object.keys(checkList).length === 0) {
      clearPerspectiveMenu()
      setPerspectiveMenuStatus('ready')
      return
    }
    let menuList = []
    menuList = await createGroupPerspective(checkList)
    menuList = await createCollapsePerspective(menuList, checkList)
    menuList = await createItemPerspective(menuList, checkList)
    if (requestId && requestId !== menuRequestRef.current) return

    setPerspectiveMenu(menuList)
    dispatch({ type: actionType.PERSPECTIVE_MENU, perspectiveMenu: menuList })
    setPerspectiveMenuStatus('ready')
  }

  useEffect(async () => {
    if (isSetMenu) return
    if (allPerspectiveList.length === 0) return
    let menuClickUrl = menuClick?.url || ''
    let [url] = menuClickUrl?.split('?')
    let { perspective, groupMenuId } = configContext.state || {}

    let [menuUrl] = pathname.split('/display')
    let samePerspective = perspective && menuUrl === perspective?.routePath
    let foundPerspective = menuClick
      ? perspectiveMenu.find(({ id }) => id === menuClick?.groupMenuId)
      : true

    if (samePerspective && menuClick && url === pathname && foundPerspective) {
      setSelectPerspective(false)
      let groupMenuId = objectPath.get(menuClick, 'menu.data.groupMenuId')
      let groupMenu = menuList.find((item) => item.id === groupMenuId)
      let defaultNavbar = objectPath.get(groupMenu, 'menu.data.defaultNavbar')
      if (defaultNavbar) {
        menuList.map((item) => {
          if (item.id === groupMenuId) {
            item.backIcon = 'fa fa-chevron-left'
            item.backUrl = '/'
          }
          return item
        })
        setPerspectiveMenu(menuList)
      } else {
        setPerspectiveMenu(perspectiveMenu)
      }
      dispatch({
        type: actionType.GROUP_MENU_ID,
        groupMenuId: menuClick?.groupMenuId,
      })
    } else {
      if (pathname === '/') {
        menuList.map((item) => {
          if (item.backIcon) {
            delete item.backIcon
            delete item.backUrl
          }
          return item
        })
        setPerspectiveMenu(menuList)
      } else {
        if (!perspectiveMenu) return
        let menuClickUrl = menuClick?.url || ''
        let [url] = menuClickUrl?.split('?')
        if (url === pathname && foundPerspective && samePerspective) {
          perspectiveMenu.map((item, index) => {
            if (item.type && item.type === 'group') {
              getCollapse(item, index)
            }
            return false
          })
          setPerspectiveMenu(perspectiveMenu)
        } else {
          if (perspectiveId) {
            setIsSetMenu(true)
            clearPerspectiveMenu()
            setPerspectiveMenuStatus('loading')
            let perspectiveMenu = await getPerspectiveMenu(perspectiveId, true)
            if (!perspectiveMenu) return
            perspectiveMenu.map((item, index) => {
              if (item.type && item.type === 'group') {
                getCollapse(item, index)
              }
              return false
            })
            setPerspectiveMenu(perspectiveMenu)
            dispatch({
              type: actionType.PERSPECTIVE_MENU,
              perspectiveMenu: perspectiveMenu,
            })
            setPerspectiveMenuStatus('ready')
          }
        }
      }
    }
  }, [
    menuClick,
    perspectiveId && pathname,
    menuList.length > 0,
    allPerspectiveList.length > 0,
  ])

  useEffect(() => {
    setIsSetMenu(false)
  }, [pathname])

  const getCollapse = (item) => {
    if (item.children) {
      item.children.filter((collapse) => {
        if (collapse.type && collapse.type === 'collapse') {
          getCollapse(collapse)
        } else if (collapse.type && collapse.type === 'item') {
          let [url] = collapse.url?.split('?')
          if (url === pathname) {
            let groupMenuId = objectPath.get(item, 'menu.data.groupMenuId')
            let groupMenu =
              perspectiveMenu.find((main) => main.id === groupMenuId) || item
            let defaultNavbar = objectPath.get(
              groupMenu,
              'menu.data.defaultNavbar',
            )
            if (item.children) {
              let menuClick = item.children.find((subItem) => {
                let subUrl = subItem.url
                if (!subUrl) return
                let [url] = subUrl.split('?')
                return url === pathname
              })
              dispatch({ type: actionType.MENU_CLICK, menuClick: menuClick })
              dispatch({
                type: actionType.GROUP_MENU_ID,
                menuClick: menuClick?.groupMenuId,
              })
            }
            if (defaultNavbar) {
              let filterMenu =
                perspectiveMenu.filter((item) => item.id === groupMenu.id) || []
              filterMenu.map((item) => {
                item.backIcon = 'fa fa-chevron-left'
                item.backUrl = '/'
                return item
              })
              setPerspectiveMenu(filterMenu)
            } else {
              setPerspectiveMenu(perspectiveMenu)
            }
          }
        }
        return false
      })
    }
  }

  const OldDropdown = () => {
    return (
      <div className={collapseMenu ? 'py-2 ' : 'py-2 d-flex'}>
        <Form.Label
          className="mb-0 d-flex align-items-center"
          style={{ height: collapseMenu ? '30px' : 'inherit' }}
        >
          {perspective?.isRoot === 0 ? (
            <Link to={perspective?.backPath || '#'}>
              <FeatherIcon icon="chevron-left" />
            </Link>
          ) : (
            <ViewInAr className="mx-1" />
          )}
        </Form.Label>
        {!collapseMenu && (
          <div className="m-r-10 w-100" style={{ zIndex: 3 }}>
            <PerspectiveAutoComplete />
          </div>
        )}
      </div>
    )
  }

  let labelStyle = collapseMenu ? { height: '30px' } : {}
  let bgStyle = {}
  let toggleStyle = {}
  if (perspective?.isRoot === 0) {
    labelStyle = {
      ...labelStyle,
      background: perspective.bgColor || '#666666',
      borderRadius: '5px',
      paddingRight: '5px',
    }
    toggleStyle = { color: perspective.textColor || 'inherit' }
    bgStyle = {
      background: perspective.bgColor || 'inherit',
      color: perspective.textColor || 'inherit',
    }
  }
  let appStyle = collapseMenu ? { fontSize: '32' } : {}
  let sessionBackPath = localStorage.getItem('sessionBackPath')
  sessionBackPath = sessionBackPath ? JSON.parse(sessionBackPath) : {}
  let locationPathname = location.pathname
  let session = objectPath.get(sessionBackPath, locationPathname)
  let locationSearch = session?.useLocationSearch ? location.search : ''
  const configuredBackPath = session?.backPath
    ? session.backPath + locationSearch
    : perspective?.backPath || '/'
  const isSurgeryPerspective =
    locationPathname === SURGERY_PERSPECTIVE_PATH ||
    locationPathname.startsWith(`${SURGERY_PERSPECTIVE_PATH}/`)
  const backPath = isSurgeryPerspective
    ? HOSP_SURGERY_DASHBOARD_PATH
    : configuredBackPath

  return (
    <div style={bgStyle} className="pb-3 perspective-header">
      <div className={collapseMenu ? 'py-2 ' : 'py-2 d-flex'}>
        <Form.Label
          className="mb-0 d-flex justify-content-center  align-items-center m-r-5 m-l-5 button-like"
          style={labelStyle}
        >
          {perspective?.isRoot === 0 ? (
            <Link
              to={backPath}
              className="d-flex align-items-center text-white"
            >
              <FeatherIcon icon="chevron-left" size={collapseMenu ? 30 : 20} />
            </Link>
          ) : null}
        </Form.Label>
        {true && (
          <div className="m-r-10  perspective-dropdown" style={{ zIndex: 3 }}>
            <PerspectiveDropdown toggleStyle={toggleStyle} />
            {/* {renderSelectingView()} */}
            {hn && firstPath && firstPath === 'patient-file' && (
              <span>HN : {hn}</span>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default NavPerspective
